module.exports = __webpack_public_path__ + "static/img/1.2050cf9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slides/1.png
// module id = fnIc
// module chunks = 94